export class UsersDto {
  id: number;
  username: string;
  password: string;
  factory: string;
  role: string;
  createdUser: string;
  isActive?: boolean;
  versionFlag?: number;
}
